import { render, staticRenderFns } from "./EditSlideDeckPage.modal.vue?vue&type=template&id=c653fc54"
import script from "./EditSlideDeckPage.modal.vue?vue&type=script&lang=ts"
export * from "./EditSlideDeckPage.modal.vue?vue&type=script&lang=ts"
import style0 from "./EditSlideDeckPage.modal.vue?vue&type=style&index=0&id=c653fc54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports